import React, { SVGProps } from 'react'

import MeasurIcon from './MeasurIcon'

export default class IconSocialFacebook extends MeasurIcon<
  SVGProps<SVGSVGElement>
> {
  render() {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <path
          d="M15 1.66667H12.5C11.3949 1.66667 10.3351 2.10565 9.55373 2.88705C8.77233 3.66846 8.33334 4.72826 8.33334 5.83333V8.33333H5.83334V11.6667H8.33334V18.3333H11.6667V11.6667H14.1667L15 8.33333H11.6667V5.83333C11.6667 5.61232 11.7545 5.40036 11.9108 5.24408C12.067 5.0878 12.279 5 12.5 5H15V1.66667Z"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}
